import React, { useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { numberFormat, amountFormatOnly, getDateInStringDDMMMYYYY, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import { DialogTitle, TripActionDialogContent, DialogActions } from '../Dialog/Dialog';
import {
  TextField,
  Checkboxes,
  Radios,
  Select,
  DatePicker,
  TimePicker,
  Switches,
  Autocomplete
} from 'mui-rff';
import {
  Typography,
  Paper,
  Link,
  Grid,
  Button,
  Card,
  Dialog,
  CardActions,
  CardContent,
  CssBaseline,
  MenuItem,
  InputAdornment,
  InputLabel,
  FormControl,
  CardHeader,
  TextField as TextInput,
  Checkbox,
  Box,
  Tabs,
  Tab,
  DialogContentText
} from '@material-ui/core';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot } from "@material-ui/lab";
// Picker
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { Form } from 'react-final-form';
import NotesIcon from '@material-ui/icons/Notes';
import {
  getTripDetailsOnly,
  updateTripStatus,
  populateSingleTripData
} from "../../../store/actions/tripActionCreator";
import {
  getVehicleLedgerData,
  getAllDrivers,
  getAllVendors
} from "../../../store/actions/vehicleActionCreator";
import { sendError, sendSucces } from "../../../utils/utils"
import inputStyles from '../css/inputs'
import {
  TRIP_STATUS,
  TRIP_DISPLAY_STATUS,
  TRIP_ACTIONS,
  TRIP_STATUS_DIALOG_TITLES,
  TRIP_STATUS_DIALOG_LABELS,
  PAYMENT_CHIPS,
  TRIP_ACTIONS_FORM_LABELS
} from "../../../store/constants";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { RoundArrowIcon } from '../../../components/icons';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';

const useStyles = makeStyles(theme => ({
  formRoot: {
    '& .MuiFormControl-root': {
      width: '100%',
      margin: '16px 0px'
    }
  },
  dialogContent: {
    padding: '16px 24px'
  },
  switchLabel: {
    marginLeft: 0
  },
  error: {
    color: 'red',
    marginBottom: 8
  },
  vehicleNumberPrefix: {
    color: "#000",
    fontWeight: 700
  },
  vehicleNumberSuffix: {
    marginLeft: 3,
    color: "#0033cc",
    marginRight: 3,
    fontWeight: 700
  },
  tripConfirmCard: {
    backgroundColor: "#f6f4f4",
    boxShadow: 'none',
    borderRadius: 8
  },
  tripTimeline: {
    marginBottom: 0,
    paddingLeft: 0,
    maxHeight: 77
  },
  textV1: {
    fontWeight: 'bold'
  },
  fsV1: {
    fontSize: 28
  },
  tripTimelineContent: {
    padding: "0px 15px",
    marginTop: -5,
  },
  tripTimelineConnector: {
    width: 1,
  },
  tripTimeDot: {
    backgroundColor: "#fff",
    margin: 0,
    border: "1px solid #c7c7c7",
  },
  tripTimelineItem: {
    "&::before": {
      flex: 0,
      padding: 0,
    },
    minHeight: 40,
  },
  labelHeader: {
    fontSize: 12,
    marginBottom: 2
  },
  partyName: {
    fontSize: 14,
    fontWeight: 600
  },
  vehicleNum: {
    fontSize: 14,
    fontWeight: 600
  },
  cardContent: {
    padding: '16px 16px !important'
  },
  bullet: {
    borderRadius: "50%",
    backgroundColor: "#c7c7c7",
    fontSize: 8,
    color: "#c7c7c7",
    margin: "0px 6px",
    //marginTop: -2
  },
  brV1: {
    borderRadius: 12
  },
  startDate: {
    fontSize: 12,
    color: '#383838',
    letterSpacing: '0.03em',
    marginTop: 3,
  },
  mtV1: {
    marginTop: 4
  },
  gridV1: {
    textAlign: 'end',
    width: '43%'
  },
  gridV2: {
    width: '43%'
  },
  divWidth: {
    minWidth: 75,
  },
  divFlex: {
    display: 'flex', alignItems: 'center'
  },
  dividerV1: {
    borderBottom: '1px solid #C8C8C8', width: '100%', marginRight: -2, marginLeft: 8
  },
  dividerV2: {
    borderBottom: '1px solid #C8C8C8', width: '100%', marginLeft: -2, marginRight: 8
  },
  paperWidthV1: {
    maxWidth: 400,
  }
}));
const getNextTripStatus = (tripStatus) => {
  const statusList = ['STARTED', 'COMPLETED', 'POD_RECEIVED', 'POD_SUBMITTED', 'PAYMENT_RECEIVED'];
  const index = statusList.indexOf(tripStatus);
  if (index > -1 && index < statusList.length - 1) {
    return statusList[index + 1];
  }
  return null;
}
const TripTimelineActionDialog = (props) => {
  const formClasses = useStyles();
  const inputClasses = inputStyles();
  let submit
  const {
    user,
    onConfirm,
    classes,
    open,
    onClose,
    onSave,
    action,
    defaultSelected,
    defaultPerson,
    location,
    dispatchTripDetailsAction,
    dispatchUpdateTripStatus,
    dispatchGetVehicleLedgerAction,
    dispatchGetAllDrivers,
    tripId,
    ...other
  } = props;
  let path = location && location.pathname ? location.pathname.split("/") : [];
  const [tripDetails, setTripDetails] = React.useState([]);
  const [completeConfirm, setCompleteConfirm] = React.useState(false);
  let tripStatus = tripDetails && tripDetails.status ? tripDetails.status : '';
  let hiredTrip = tripDetails && tripDetails.vehicle && tripDetails.vehicle.ownershipType && tripDetails.vehicle.ownershipType == 'HIRED' ? true : false;
  let vendorId = hiredTrip && tripDetails && tripDetails.vehicle && tripDetails.vehicle.vendorId ? tripDetails.vehicle.vendorId : 0;
  let title = '';
  const fetchTrip = (tripId) => {
    dispatchTripDetailsAction(tripId, (response) => {
      setTripDetails(populateSingleTripData(response, false));
    });
  }
  useEffect(() => {
    if (tripId) {
      fetchTrip(tripId)
    }
  }, [dispatchTripDetailsAction]);
  const [dialogopen, setDialogOpen] = React.useState(open);
  const validate = values => {
    const errors = {};
    if (!values.date) {
      errors.date = 'Please Select a date';
    }
    return errors;
  };
  const handleConfirm = (e) => {
    setCompleteConfirm(true)
  }
  const handleClose = (status) => {
    onClose(false);
  };
  const handleSave = (status) => {
    onSave(false);
  };
  const onSubmit = async values => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(300);
    //window.alert(JSON.stringify(values, 0, 2));
    let newStatus = getNextTripStatus(tripStatus);
    let requestData = {
      status: newStatus
    };
    let date = Math.round((new Date(values.date).setHours(0, 0, 0, 0) / 1000));
    if (newStatus === 'COMPLETED') {
      requestData['tripCompletedDate'] = date;
      requestData['endOdometerReading'] = values.endOdometerReading;
    }
    dispatchUpdateTripStatus(
      tripDetails.id,
      requestData, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          dispatchGetVehicleLedgerAction({
            fleetOwnerId: user.userInfo.entityId,
            ownershipType: ["SELF", "HIRED"],
            vehicleStatus: ["AVAILABLE", "ONTRIP"],
          },
            (response) => {
              dispatchGetAllDrivers(
                () => {
                  handleSave();
                }, () => {
                });
            },
            () => {
            }
          );
        }
      },
      () => {
      }
    )

  };
  const getFormFields = (values) => {
    let commonFields = [
      {
        size: 6,
        visible: true,
        field: (
          <div>
            <DatePicker
              disableFuture
              name="date"
              margin="normal"
              style={{ paddingRight: 8 }}
              variant="inline"
              inputVariant="outlined"
              size="small"
              format="dd-MM-yyyy"
              label={'Completed Date'}
              placeholder="Enter a Date"
              required={true}
              dateFunsUtils={DateFnsUtils}
              InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={formClasses.eventIcon}></EventOutlinedIcon></InputAdornment> }}
            />
          </div>
        ),
      },
      {
        size: 6,
        visible: true,
        inline: false,
        field: (
          <TextField
            label={"End KMs"}
            placeholder={'End Kms'}
            style={{ paddingLeft: 8 }}
            name="endOdometerReading"
            InputProps={{
              endAdornment: <InputAdornment position="start">KMs</InputAdornment>,
            }
            }
            fullWidth={true}
            variant="outlined"
            size="small"
            margin="normal"
          />
        ),
      }
    ];
    return commonFields;
  }
  let initialValues = {
    date: new Date()
  };

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth='xs'
        onClose={handleClose}
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        aria-labelledby={"trip-timeline-actions-title-for-complete-trip"}
        open={dialogopen}
        // className={formClasses.brV1}
        classes={{ paperScrollPaper: formClasses.brV1, paperWidthXs: formClasses.paperWidthV1 }}
      >
        <DialogTitle id={"trip-actions-title-for-complete-trip"} onClose={handleClose}>
          {!completeConfirm ? "Trip Confirmation" : 'Mark Trip Delivered'}
        </DialogTitle>
        <TripActionDialogContent dividers>
          <DialogContentText id="trip-actions-title-for-complete-trip">
            <span className={formClasses.vehicleNumberPrefix}>{tripDetails ? tripDetails.vehicleNumberPrefix : ""}</span><span className={formClasses.vehicleNumberSuffix}>{tripDetails ? tripDetails.vehicleNumberSuffix : ""}</span> is currently on trip. To add this truck, kindly confirm trip completion.
          </DialogContentText>
          <Card className={formClasses.tripConfirmCard}>
            <CardContent className={formClasses.cardContent}>
              <Typography color="textSecondary" className={formClasses.labelHeader}>
                {
                  <>
                    <span>
                      Party Name
                    </span>
                  </>
                }
              </Typography>
              <Typography variant="h5" component="h2" className={formClasses.partyName} gutterBottom>
                {
                  <>
                    <span>{tripDetails && tripDetails.partyName}</span>
                  </>
                }
              </Typography>
              <Typography color="textSecondary" className={formClasses.labelHeader}>
                {
                  <>
                    <span>
                      Truck No.
                    </span>
                  </>
                }
              </Typography>
              <Typography
                variant="h5"
                component="h2"
                className={formClasses.vehicleNum}
                gutterBottom
              >
                {
                  <>
                    <span>
                      {tripDetails && tripDetails.vehicleNumberPrefix ? tripDetails.vehicleNumberPrefix : ""}
                      <span className={formClasses.vehicleNumberSuffix}>
                        {tripDetails && tripDetails.vehicleNumberSuffix ? tripDetails.vehicleNumberSuffix : ""}
                      </span>
                      {tripDetails && tripDetails.driverName && <>
                        <FiberManualRecordIcon className={formClasses.bullet}></FiberManualRecordIcon>
                        <span>
                          {tripDetails.driverName}
                        </span>
                      </>}
                      {/* {tripDetails && tripDetails.vehicle ? tripDetails.vehicle.vehicleBodyType : ""} */}
                    </span>
                  </>
                }
              </Typography>

              <Typography color="textSecondary" className={formClasses.labelHeader}>
                {
                  <>
                    <div className={formClasses.mtV1}>
                      Route
                    </div>
                  </>
                }
              </Typography>


              {/* <Timeline className={formClasses.tripTimeline}>
                  <TimelineItem className={formClasses.tripTimelineItem}>
                    <TimelineSeparator>
                      <TimelineDot className={formClasses.tripTimeDot} />
                      <TimelineConnector className={formClasses.tripTimelineConnector} />
                    </TimelineSeparator>
                    <TimelineContent className={formClasses.tripTimelineContent}>
                      <span className={formClasses.listSecondaryText}>
                        <span style={{ color: 'black' }}>
                          {tripDetails && tripDetails.startLocation ? tripDetails.startLocation : ""}
                        </span>
                        {tripDetails && tripDetails.startDate && <>
                          <FiberManualRecordIcon className={formClasses.bullet}></FiberManualRecordIcon>
                          <span>
                            {tripDetails.startDate}
                          </span>
                        </>}
                      </span>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem className={formClasses.tripTimelineItem}>
                    <TimelineSeparator>
                      <TimelineDot className={formClasses.tripTimeDot} />
                    </TimelineSeparator>
                    <TimelineContent className={formClasses.tripTimelineContent}>
                      <span style={{ color: 'black' }}>
                        {tripDetails && tripDetails.destinationLocation ? tripDetails.destinationLocation : ""}
                      </span>
                    </TimelineContent>
                  </TimelineItem>
                </Timeline> */}

              <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
              >
                <Grid className={formClasses.gridV2}>
                  <div className={formClasses.divFlex}>
                    <div className={formClasses.divWidth}>
                      <div className={formClasses.textV1}>{tripDetails && tripDetails.startLocation ? tripDetails.startLocation : ""}</div>
                      <div className={formClasses.startDate}>{tripDetails && tripDetails.startDate ? tripDetails.startDate : ""}</div>
                    </div>
                    <div className={formClasses.dividerV1}></div>
                  </div>
                </Grid>

                <div>
                  <RoundArrowIcon className={formClasses.fsV1} />
                </div>

                <Grid className={formClasses.gridV1}>
                  <div className={formClasses.divFlex}>
                    <div className={formClasses.dividerV2}></div>
                    <div className={formClasses.divWidth}>
                      <div className={formClasses.textV1}>{tripDetails && tripDetails.destinationLocation ? tripDetails.destinationLocation : ""}</div>
                      <div className={formClasses.startDate}>{tripDetails && tripDetails.completeDate ? tripDetails.completeDate : "--"}</div>
                    </div>
                  </div>
                </Grid>
              </Grid>

            </CardContent>
          </Card>
          {completeConfirm && <Form
            onSubmit={onSubmit}
            initialValues={initialValues}
            validate={validate}
            render={({ handleSubmit, form, submitting, pristine, values }) => {
              submit = handleSubmit; return (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid container alignItems="flex-start" spacing={0}>
                    {getFormFields(values).map((item, idx) => item.visible ? (
                      <Grid item xs={item.size} key={idx}>
                        {item.field}
                      </Grid>
                    ) : null)}
                  </Grid>
                  {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                </form>
              )
            }}
          />}
        </TripActionDialogContent>
        <DialogActions>
          <Button variant="outlined" className={!completeConfirm ? 'modal-close-cta-outlined' : 'modal-close-cta'} onClick={handleClose} >
            {!completeConfirm ? 'Cancel' : 'Close'}
          </Button>
          {completeConfirm && <Button variant="outlined" className='modal-save-cta-blue' onClick={event => submit(event)} >
            Complete Trip
          </Button>}
          {!completeConfirm && <Button variant="outlined" className='modal-save-cta-outlined' onClick={handleConfirm} >
            Confirm
          </Button>}
        </DialogActions>
      </Dialog>
    </div>
  );
}
const TripTimelineActionDialogWithRouter = withRouter(TripTimelineActionDialog);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchTripDetailsAction: (tripId, onSuccess, onError) =>
    dispatch(getTripDetailsOnly(tripId, onSuccess, onError)),
  dispatchUpdateTripStatus: (tripId, data, onSuccess, onFailure) => { dispatch(updateTripStatus(tripId, data, onSuccess, onFailure)) },
  dispatchGetVehicleLedgerAction: (requestData, onSuccess, onFailure) => { dispatch(getVehicleLedgerData(requestData, onSuccess, onFailure)) },
  dispatchGetAllDrivers: (onSuccess, onFailure) => dispatch(getAllDrivers(null, onSuccess, onFailure)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripTimelineActionDialogWithRouter);